// Components==============
import LabelWrapper from 'components/UI/Label/LabelWrapper';
import RichText from 'components/UI/RichText/RichText';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import './Body.module.scss';
// =========================

export default function Body({ training }: { training?: TrainingEntity }) {
  const translate = useTranslate();

  return (
    <div styleName="wrapper">
      <div styleName="description-area">
        <p>{training?.description}</p>
        {training?.attachments
          ?.filter((a) => a.attachment_type === 'text')
          .sort((a, b) => (a.order_index || 0) - (b.order_index || 0))
          .map((a) => {
            const { title } = JSON.parse(a.attachment_data);
            const description = JSON.parse(a.attachment_data).text;

            return (
              <div key={a.id}>
                <strong>{title}</strong> <RichText content={description} />
              </div>
            );
          })}
      </div>
      <div styleName="labels">
        <LabelWrapper
          title={translate('general.terms.categories')}
          labels={training?.categories?.map((cat) => cat.category.name)}
        />
        {/* <LabelWrapper
          title={translate('general.terms.skills')}
          labels={training?.skills?.map((s) => s.skill.name)}
        /> */}
      </div>
    </div>
  );
}
